type Props = {
  className?: string;
};

export function SentryLogo({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      className={className}
      fill="currentColor"
    >
      <path d="M23.663,19.246l-9.72-16.71C13.497,1.798,12.749,1.5,12,1.5s-1.495,0.444-1.943,1.036L6.917,8.007l0.748,0.444	c2.393,1.331,4.336,3.253,5.682,5.619c1.197,2.071,1.944,4.288,2.094,6.656h-2.243c-0.149-1.923-0.748-3.846-1.794-5.621	c-1.047-2.07-2.692-3.697-4.785-4.88L5.87,9.782L2.88,14.81l0.747,0.444c1.944,1.182,3.29,3.104,3.589,5.323H2.281	c-0.149,0-0.3-0.148-0.3-0.148s-0.148-0.148,0-0.296l1.348-2.367c-0.449-0.442-1.048-0.74-1.646-0.886l-1.346,2.367	c-0.449,0.74-0.449,1.479,0,2.219C0.785,22.204,1.383,22.5,2.28,22.5h6.879v-0.886c0-1.627-0.449-3.106-1.196-4.586	c-0.599-1.182-1.496-2.07-2.542-2.808l1.047-1.924c1.347,1.034,2.543,2.218,3.439,3.698c1.047,1.773,1.496,3.697,1.496,5.619v0.886	h5.831v-0.886c0-2.957-0.747-5.916-2.392-8.577c-1.197-2.368-3.141-4.289-5.385-5.768L11.7,3.424C11.852,3.275,12,3.275,12,3.275	c0.15,0,0.15,0,0.299,0.148l9.721,16.709c0.148,0.146,0,0.296,0,0.296s-0.15,0.148-0.3,0.148h-2.243v1.775h2.243	c0.896,0.147,1.495-0.148,1.943-0.886C24.112,20.726,24.112,19.986,23.663,19.246z" />
    </svg>
  );
}
